import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import axios from 'axios';

import {
  questionsByCategoryId,
  saveAnswers,
  answersBySiteId,
  inputList1,
  inputList2,
  // allQuestion,
} from '../../../configs';
import { Button, LoadingSpinner, Tabs } from '../../elements';
import RenderInputLoop from '../RenderInputLoop';
import WaterCategoryContent from '../WaterCategoryContent';
import Swal from 'sweetalert2';

/*
  Question Documentations
  dataType : text, longtext, number, option
*/
export default function QuestionCollections(props) {
  const { tabData, setCategoryTitle, numberOfQuestions } = props;
  const navigate = useNavigate();

  const [inputList, setInputList] = useState([]);
  console.log('input list', inputList);
  const [numberOfAnswer, setNumberOfAnswer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isInitialAnswers, setIsInitialAnswers] = useState();
  const [submitState, setSubmitState] = useState('');
  const [siteIdState, setSiteIdState] = useState(59);
  const [activeCategoryId, setActiveCategoryId] = useState();

  // Axios Abort Controller
  const questionSource = axios.CancelToken.source();

  // func. for count total answer in localStorage & save to State
  const countAnswerInStorage = () => {
    const dataLocal = JSON.parse(localStorage.getItem('answerGroup'));
    const totalAnswerSaved = dataLocal ? dataLocal.length : 0;
    setNumberOfAnswer(totalAnswerSaved);
    // console.log('total answer saved', totalAnswerSaved);
    // console.log('total question', numberOfQuestions);
    // console.log('total answer', numberOfAnswer);
  };

  const loadInitialQuestionsAndAnswers = async (siteId, cancelTokenAnswer) => {
    try {
      setLoading(true);

      // get data category & all question (for counting total question)
      handleChangeTab(1);
      const responseAnswers = await axios.get(answersBySiteId(siteId), {
        cancelToken: cancelTokenAnswer,
      });

      // response for allQuestion
      if (responseAnswers.status === 200) {
        const allAnswerData = responseAnswers.data;
        const newQuestionData = [];
        console.log('all question data', allAnswerData);

        allAnswerData.forEach((element) => {
          const data = {
            question_id: element.questionId,
            answer: element.answer,
          };
          newQuestionData.push(data);
        });

        localStorage.setItem('answerGroup', JSON.stringify(newQuestionData));

        setNumberOfAnswer(allAnswerData.length);

        if (allAnswerData.length !== 0) {
          setIsInitialAnswers(true);
        } else {
          setIsInitialAnswers(false);
        }
      }

      setLoading(false);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('fetch initial question/answer count aborted.');
      } else {
        console.log(error.message);
        console.log(error.res);
        setLoading(false);
      }
    }
  };

  // func. for fetch a group of question data
  const loadQuestionGroup = async (categoryId, cancelToken) => {
    try {
      setLoading(true);
      const response = await axios.get(questionsByCategoryId(categoryId), {
        cancelToken: cancelToken,
      });
      const data = response.data;
      setLoading(false);

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('fetch question group aborted.');
      } else {
        console.log(error.message);
        console.log(error.res);
        setLoading(false);
        return null;
      }
    }
  };

  const handleChangeTab = async (categoryId) => {
    // check if categoryId 98 or 99 (water)
    let categoryIdNow;
    if (+categoryId === 98) {
      categoryIdNow = 10;
    } else if (+categoryId === 99) {
      categoryIdNow = 11;
    } else {
      categoryIdNow = categoryId;
    }

    // fetch question from API
    const questionGroup = await loadQuestionGroup(
      categoryIdNow,
      questionSource.token
    );
    // set into the state
    setInputList(questionGroup);
    // set active category state
    setActiveCategoryId(categoryId);

    // count total answer
    countAnswerInStorage();
  };

  const handleSave = (e, inputListData) => {
    e.preventDefault();

    const formData = e.target;
    let groupData = [];

    for (let index = 0; index < inputList.length; index++) {
      const currentInputData = inputListData[index];
      const variableName = `inputWithQuestionId${currentInputData.questionId}`;

      if (formData[variableName]) {
        const currentInputValue = {
          question_id: currentInputData.questionId,
          answer: formData[variableName].value,
        };

        groupData.push(currentInputValue);
      }
    }

    // get localStorage value
    const storageData = JSON.parse(localStorage.getItem('answerGroup'));

    // Check if localStorage is empty/now
    if (!storageData) {
      // if empty just save to localStorage
      localStorage.setItem('answerGroup', JSON.stringify(groupData));
    } else {
      // if not empty, combine it
      storageData.push.apply(storageData, groupData);

      // then check if there's a duplicate or not
      const ids = storageData.map((element) => element.question_id);
      const notDuplicatedData = storageData.filter(
        ({ question_id }, index) => !ids.includes(question_id, index + 1)
      );

      // save it to localStorage
      localStorage.setItem('answerGroup', JSON.stringify(notDuplicatedData));
    }

    // count total answer
    countAnswerInStorage();

    // notify user that the data has been saved on the local
    Swal.fire({
      title: 'Success!',
      text: 'Data has been saved in Local Browser!',
      icon: 'success',
      confirmButtonColor: '#006CB7',
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    handleSave(e, inputList);

    const allAnswerData = JSON.parse(localStorage.getItem('answerGroup'));
    // const dataForm = {
    //   site_id: siteIdState,
    //   answers: allAnswerData,
    // };
    const dataForm = allAnswerData;

    if (!isInitialAnswers) {
      axios
        .post(`${saveAnswers}/${siteIdState}`, JSON.stringify(dataForm), {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          console.log('ini response post', response);

          // clear localStorage & state related
          localStorage.removeItem('answerGroup');
          setNumberOfAnswer(0);
        })
        .catch((err) => {
          console.log('error', err);
          console.log('error message', err.message);
          Swal.fire({
            title: 'Failed to send data!',
            text: err.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        });
    } else {
      axios
        .put(`${saveAnswers}/${siteIdState}`, JSON.stringify(dataForm), {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          console.log('ini response put', response);

          // clear localStorage & state related
          localStorage.removeItem('answerGroup');
          setNumberOfAnswer(0);
        })
        .catch((err) => {
          console.log('error', err);
          console.log('error message', err.message);
          Swal.fire({
            title: 'Failed to send data!',
            text: err.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        });
    }

    Swal.fire({
      title: 'Success!',
      text: 'Data has been saved in Database!',
      icon: 'success',
      confirmButtonColor: '#006CB7',
    });
  };

  useEffect(() => {
    // --for dummy--
    // setInputList(inputList1);
    const sourceAnswer = axios.CancelToken.source();

    loadInitialQuestionsAndAnswers(siteIdState, sourceAnswer.token);

    // count total answer
    countAnswerInStorage();

    return () => {
      /* TODO document why this arrow function is empty */
    };
  }, []);

  return (
    <div className={styles.root}>
      <Tabs
        tabData={tabData}
        setCategoryTitle={setCategoryTitle ? setCategoryTitle : ''}
        handleChangeTab={handleChangeTab}
        // for used in "key" attribute on .map() in <Tabs/>
        parentComponentName="questionCollection"
        loading={loading}
        setLoading={setLoading}
        // --for Dummy--
        setContentData={setInputList}
        contentData={[inputList1, inputList2]}
      />
      <div className={styles.questionContent}>
        <div className={styles.questionsWrapper}>
          {loading ? (
            <LoadingSpinner />
          ) : parseInt(activeCategoryId) === 98 ? (
            <WaterCategoryContent
              categoryId={98}
              siteId={siteIdState}
              loading={loading}
              setLoading={setLoading}
              // get from inputlist & remove the first 2 question
              inputListSliced={inputList.slice(2)}
            />
          ) : parseInt(activeCategoryId) === 99 ? (
            <WaterCategoryContent
              categoryId={99}
              siteId={siteIdState}
              loading={loading}
              setLoading={setLoading}
              // get from inputlist & remove the first 3 question
              inputListSliced={inputList.slice(3)}
            />
          ) : (
            <>
              <form
                onSubmit={(e) => {
                  if (submitState === 'submit') {
                    return handleSubmit(e);
                  }
                  return submitState === 'save' ? handleSave(e, inputList) : '';
                }}
              >
                {inputList.length !== 0 ? (
                  <RenderInputLoop
                    inputList={inputList}
                    storage={JSON.parse(localStorage.getItem('answerGroup'))}
                  />
                ) : (
                  'data kosong'
                )}
                <div className={styles.buttonAreaWrapper}>
                  <Button
                    label="Submit"
                    type="submit"
                    color="primary"
                    onClick={() => setSubmitState('submit')}
                    // disabled={numberOfQuestions !== numberOfAnswer}
                  />
                  <Button
                    label="Save"
                    type="submit"
                    color="secondary"
                    onClick={() => setSubmitState('save')}
                    className={styles.btnSave}
                  />
                </div>
              </form>
              <Button
                className={styles.btnBack}
                label="Back"
                color="white"
                onClick={() => navigate(-1)}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
